import type { Dict } from "../../../../shared/i18n";

/** Общие подписи: категории, статусы, форматы (lib/meta.ts, lib/format.ts, lib/api.ts) */
export default {
  // категории мест
  "Город / база": ["Miestas / bazė", "City / base"],
  "Достопримечательность": ["Lankytina vieta", "Sight"],
  "Природа": ["Gamta", "Nature"],
  "Пляж": ["Paplūdimys", "Beach"],
  "Еда": ["Maistas", "Food"],
  "Кафе / кофе": ["Kavinė / kava", "Café / coffee"],
  "Бары / ночь": ["Barai / naktinis gyvenimas", "Bars / nightlife"],
  "Жильё": ["Būstas", "Accommodation"],
  "Активность": ["Veikla", "Activity"],
  "Рынок / шопинг": ["Turgus / apsipirkimas", "Market / shopping"],
  "Транспорт": ["Transportas", "Transport"],
  "Другое": ["Kita", "Other"],
  // статус места
  "Идея": ["Idėja", "Idea"],
  "идея": ["idėja", "idea"],
  "Хотим": ["Norime", "Want"],
  "хотим": ["norime", "want"],
  "Были": ["Buvome", "Visited"],
  "были": ["buvome", "visited"],
  "Отказались": ["Atsisakėme", "Skipped"],
  "нет": ["ne", "no"],
  // виды пунктов плана
  "Посещение": ["Apsilankymas", "Visit"],
  "Ночёвка": ["Nakvynė", "Stay"],
  "Переезд": ["Persikėlimas", "Transport"],
  "Заметка": ["Pastaba", "Note"],
  // статусы пунктов
  "черновик": ["juodraštis", "draft"],
  "в плане": ["suplanuota", "planned"],
  "забронировано": ["rezervuota", "booked"],
  "сделано": ["atlikta", "done"],
  "отменено": ["atšaukta", "cancelled"],
  // транспорт
  "Самолёт": ["Lėktuvas", "Flight"],
  "Поезд": ["Traukinys", "Train"],
  "Ночной автобус": ["Naktinis autobusas", "Sleeper bus"],
  "Автобус": ["Autobusas", "Bus"],
  "Машина / трансфер": ["Automobilis / pervežimas", "Car / transfer"],
  "Мотобайк": ["Motoroleris", "Motorbike"],
  "Лодка / паром": ["Valtis / keltas", "Boat / ferry"],
  "Такси / Grab": ["Taksi / Grab", "Taxi / Grab"],
  "Пешком": ["Pėsčiomis", "On foot"],
  // роли
  "владелец": ["savininkas", "owner"],
  "редактор": ["redaktorius", "editor"],
  "только просмотр": ["tik peržiūra", "view only"],
  // чек-лист
  "Документы": ["Dokumentai", "Documents"],
  "Брони": ["Rezervacijos", "Bookings"],
  "Деньги": ["Pinigai", "Money"],
  "Здоровье и страховка": ["Sveikata ir draudimas", "Health & insurance"],
  "Вещи": ["Daiktai", "Packing"],
  "Связь и приложения": ["Ryšys ir programėlės", "Connectivity & apps"],
  // расходы
  "Активности": ["Veiklos", "Activities"],
  "Покупки": ["Pirkiniai", "Shopping"],
  "Визы и сборы": ["Vizos ir mokesčiai", "Visas & fees"],
  // форматы
  "через {n} день|через {n} дня|через {n} дней": ["po {n} dienos|po {n} dienų|po {n} dienų", "in {n} day|in {n} days"],
  "день {n}": ["{n} diena", "day {n}"],
  "поездка завершена": ["kelionė baigėsi", "trip is over"],
  "{m} мин": ["{m} min.", "{m} min"],
  "{h} ч {m} мин": ["{h} val. {m} min.", "{h} h {m} min"],
  "{h} ч": ["{h} val.", "{h} h"],
  "только что": ["ką tik", "just now"],
  // api
  "Нет связи с сервером": ["Nėra ryšio su serveriu", "No connection to the server"],
  "Ошибка {status}": ["Klaida {status}", "Error {status}"],
  // журнал изменений (lib/activity.ts)
  "Добавлено место: {name}": ["Pridėta vieta: {name}", "Added place: {name}"],
  "Изменено место: {name}": ["Pakeista vieta: {name}", "Edited place: {name}"],
  "Удалено место: {name}": ["Ištrinta vieta: {name}", "Deleted place: {name}"],
  "Добавлен пункт плана: {name}": ["Pridėtas plano punktas: {name}", "Added plan item: {name}"],
  "Изменён пункт плана: {name}": ["Pakeistas plano punktas: {name}", "Edited plan item: {name}"],
  "Удалён пункт плана: {name}": ["Ištrintas plano punktas: {name}", "Deleted plan item: {name}"],
  "Добавлена задача: {name}": ["Pridėta užduotis: {name}", "Added task: {name}"],
  "Изменена задача: {name}": ["Pakeista užduotis: {name}", "Edited task: {name}"],
  "Удалена задача: {name}": ["Ištrinta užduotis: {name}", "Deleted task: {name}"],
  "Добавлен расход: {name}": ["Pridėta išlaida: {name}", "Added expense: {name}"],
  "Изменён расход: {name}": ["Pakeista išlaida: {name}", "Edited expense: {name}"],
  "Удалён расход: {name}": ["Ištrinta išlaida: {name}", "Deleted expense: {name}"],
  "Добавлен источник: {name}": ["Pridėtas šaltinis: {name}", "Added source: {name}"],
  "Изменён источник: {name}": ["Pakeistas šaltinis: {name}", "Edited source: {name}"],
  "Удалён источник: {name}": ["Ištrintas šaltinis: {name}", "Deleted source: {name}"],
  "Добавлен виджет: {name}": ["Pridėtas valdiklis: {name}", "Added widget: {name}"],
  "Изменён виджет: {name}": ["Pakeistas valdiklis: {name}", "Edited widget: {name}"],
  "Удалён виджет: {name}": ["Ištrintas valdiklis: {name}", "Deleted widget: {name}"],
  "Изменены параметры поездки": ["Pakeisti kelionės nustatymai", "Trip settings changed"],
  "Отмена: {text}": ["Atšaukta: {text}", "Undone: {text}"],
  // переключатель языка (components/LangSwitch.tsx)
  "Язык": ["Kalba", "Language"],
  // места, выпавшие из плана (карта и вкладка «Места»)
  "Выпало из плана": ["Iškrito iš plano", "Dropped from the plan"],
  "Выпали из плана": ["Iškrito iš plano", "Dropped from plan"],
  "Эти места отмечены «хотим», но ни один пункт плана их больше не использует.": ["Šios vietos pažymėtos „norime“, bet jų nebenaudoja nė vienas plano punktas.", "These places are marked “want”, but no plan item uses them any more."],
  "Вернуть в идеи": ["Grąžinti į idėjas", "Move back to ideas"],
  "Отметить «отказались»": ["Pažymėti „atsisakėme“", "Mark as skipped"],
  "Удалить {n} место?|Удалить {n} места?|Удалить {n} мест?": ["Ištrinti {n} vietą?|Ištrinti {n} vietas?|Ištrinti {n} vietų?", "Delete {n} place?|Delete {n} places?"],
  "{n} место вернулось в идеи|{n} места вернулись в идеи|{n} мест вернулись в идеи": ["{n} vieta grąžinta į idėjas|{n} vietos grąžintos į idėjas|{n} vietų grąžinta į idėjas", "{n} place moved back to ideas|{n} places moved back to ideas"],
  "{n} место отмечено «отказались»|{n} места отмечены «отказались»|{n} мест отмечены «отказались»": ["{n} vieta pažymėta „atsisakėme“|{n} vietos pažymėtos „atsisakėme“|{n} vietų pažymėta „atsisakėme“", "{n} place marked as skipped|{n} places marked as skipped"],
  "Удалено {n} место|Удалено {n} места|Удалено {n} мест": ["Ištrinta {n} vieta|Ištrintos {n} vietos|Ištrinta {n} vietų", "Deleted {n} place|Deleted {n} places"],
} satisfies Dict;
